import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { Version } from '@apps/root/models';

@Injectable({
    providedIn: 'root'
})
export class VersionService
{
    constructor (private http: HttpClient)
    { }

    getDeployedVersion (): Observable<Version>
    {
        return this.http.get<Version>(`assets/version.json?ts=${Date.now()}`);
    }
}
